import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

const TipoDocumentoFormGroup = ({ iTouched, iError, fIsSubmitting, flagEditarComentarios, flagNota, flagEditar }) => {
  return (
    <Form.Group>
      <Form.Label text='T. DOC' htmlFor='select-tipoDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting || flagNota || flagEditarComentarios || flagEditar}
              isInvalid={iTouched && iError}
              id='select-tipoDocumento'
            >
              <>
                {flagNota ? (
                  <option value={TiposDeDocumentoSunatConstant.NOTA_CREDITO}>
                    {TiposDeDocumentoSunatConstant.__dictionary[TiposDeDocumentoSunatConstant.NOTA_CREDITO].nombre}
                  </option>
                ) : (
                  <>
                    {TiposDeDocumentoSunatConstant.__ventasArray.map((val, key) => (
                      <option key={key} value={val.id}>
                        {val.nombre}
                      </option>
                    ))}
                  </>
                )}
              </>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
